import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { bi } from '../../../../services/loggers/bi';
import { calculateTabName } from '../../../bi';
import { isStandalone } from '../../../env/utils';
import { useFirst } from '../../../hoc/withFirst';
import { useMMGRSettings } from '../../../hoc/withMMGRSettings';
import { trackMediaManagerOpened } from '../../../hoc/withMMGRSettings/utils';
import { toSettingsLayout } from '../../../layout';

export const useBILoggerTabNameAndLayout = ({ source, layout }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    bi.updateDefaults({
      tabName: calculateTabName({ pathname, source }),
      layout: toSettingsLayout(layout),
    });
  }, [pathname, source, layout]);

  const { mmgrSettings } = useMMGRSettings();
  const [isFirst, setFirst] = useFirst('appOpenedAnalytics');

  useEffect(() => {
    if (isStandalone || process.env.NODE_ENV === 'test') {
      trackMediaManagerOpened({ isFirst: isFirst.current, setFirst, mmgrSettings });
    }
  }, []);
};
